// Residue Menu component for adding residues to filtering algorithm

import React from 'react';
import resdict from '../visualizer-tool/data/resdict.json';
import { Input, Icon } from 'semantic-ui-react';

// helper functions from visualisation tool
import SNFGsvg from '../visualizer-tool/glycan-interpreter/snfgSVG';

//css
import '../../pages/css/databasehome.css';

// residues for dropdown, mapping to its SNFG representation
const Residues = Object.keys(resdict).map((residue) => ({
    key: residue,
    text: residue,
    value: residue,
    flag: <SNFGsvg snfg={residue} />
  }));
  
export default function ResidueMenu ({ addResidue, toggleResidueMenu }) {
  const [searchQuery, setSearchQuery] = React.useState('');

  const filteredResidues = Residues.filter((residue) => {
    return residue.text.toLowerCase().includes(searchQuery.toLowerCase());
  });
    
    return (
      <div className='res-menu'>
        <div  style={{position:"sticky", top:"0", backgroundColor:'white', padding:'2vh'}}>
          <h3 style={{ display:'flex', justifyContent:'space-between'}}>Residues: <Icon name='close' size='small' onClick={toggleResidueMenu}/></h3>
          <Input 
            style={{marginBottom:'2vh'}} 
            fluid 
            icon='search' 
            placeholder='Search...' 
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 0.3fr)' }}>
          {filteredResidues.map((residue) => (
            <div onClick={() => addResidue(residue.text)} key={residue.key} style={{ textAlign: 'center', marginBottom:'5vh'}}>
              <SNFGsvg snfg={residue.text}  />
              <strong >{residue.text}</strong>
            </div>
          ))}
        </div>
      </div>
    );
};